import { Component, effect, input, signal } from '@angular/core';
import { CURRENCY_MAP } from '../../../shared/constants';
import { Product } from '../../../shared/types/product';
import { ResponsiveService } from '../services/responsive.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
declare let gtag: Function;

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    standalone: true,
    imports: [CurrencyPipe, DatePipe, MatCardModule, MatIconModule, MatButtonModule, MatTooltipModule]
})
export class ProductCardComponent {
  readonly product = input.required<Product>();
  readonly cardWidth = input<number | null>(null);
  readonly debugMode = typeof window !== 'undefined' && window.location.search.includes('debug');
  currencyMap = CURRENCY_MAP;
  seen = signal(false);

  constructor(private readonly responsiveService: ResponsiveService) {
    effect(() => {
      const product = this.product();
      if (product && product.imagename) {
        let imageName = product.imagename;
        const imageParts = imageName.split('.');
        if (this.responsiveService.isSmallScreen()) {
          imageParts.splice(1, 0, '_AC_UL114_SR114,114_');
        } else {
          imageParts.splice(1, 0, '_AC_UL200_SR220,200_');
        }
        imageName = imageParts.join('.');
        product.imageurl = `https://images-na.ssl-images-amazon.com/images/I/${imageName}`;
      }
      if (product && localStorage.getItem(`${product.asin}_${product.usedprice}`) !== null) {
        this.seen.set(true);
      } else {
        this.seen.set(false);
      }
    });
  }

  markViewed() {
    const product = this.product();
    localStorage.setItem(`${product.asin}_${product.usedprice}`, JSON.stringify(Date.now()));
    this.seen.set(true);
  }
}
